import React from 'react';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import slugify from 'slugify';
import useStoryblok from '~/utils/storyblok-service';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import TextCard from '~/components/TextCard';
import FaqSection from '~/components/Dynamic/FaqSection';
import styled from 'styled-components';
const FaqWrapper = styled.div`
  .faq-item {
    header {
      padding: 2rem 0;
      &.is-selected {
        padding-bottom: 1.5rem;
        + div {
          margin-top: 0;
        }
      }
    }
  }
`;

function Faqs({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;

  const scrollToTop = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };

  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />
      <section className="pt-10 -mt-20 overflow-hidden text-white bg-light-blue">
        <div className="container flex flex-col items-center pt-24 md:flex-row pt-42">
          <div className="flex md:w-6/12">
            <TextCard
              className={`text-center md:text-left md:max-w-lg sm:pr-10 text-black`}
              tag={`h1`}
              headingClass={`text-black`}
              heading={content.heroHeading}
            />
          </div>
          <div className="flex justify-center mt-12 md:w-6/12 md:mt-0">
            <div className="max-w-[185px] mb-[-7px]">
              <StaticImage src={`../assets/images/faqs/faqs-hero.png`} alt="" placeholder="tracedSVG" />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="my-20 md:container md:my-32">
          <div className="flex flex-wrap items-start -ml-12">
            <aside className="pl-12 w-full md:w-3/12 mb-8 lg:mb-0 hidden justify-evenly lg:block lg:sticky top-[140px]">
              {content?.faqSection?.length > 0 &&
                content.faqSection
                  .filter((c) => c?.textCard[0]?.heading?.length > 0)
                  .map((cat, i) => (
                    <div key={`faqcat-${i}`} className="w-full lg:w-auto">
                      <a
                        href={'#' + slugify(cat?.textCard[0]?.heading, { lower: true })}
                        className={`inline-block cursor-pointer mb-4 leading-none font-heading text-17px opacity-60 transition-opacity duration-200 hover:opacity-100`}
                      >
                        {cat?.textCard[0]?.heading}
                      </a>
                    </div>
                  ))}
            </aside>

            <div className="w-full pl-12 -mt-28 lg:w-9/12">
              {content?.faqSection?.length > 0 &&
                content?.faqSection?.map((blok) => (
                  <div key={blok._uid} className="my-28" id={slugify(blok?.textCard[0]?.heading, { lower: true })}>
                    <FaqWrapper>
                      <FaqSection blok={blok} />
                    </FaqWrapper>
                  </div>
                ))}

              <div
                className="px-6 md:px-0 text-20px font-heading font-bold tracking-2 leading-[1.27] flex items-center cursor-pointer max-w-45 mx-auto"
                onClick={scrollToTop}
              >
                <p>{content?.backToTop || 'Back to the top'}</p>
                <div className="ml-3">
                  <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1" fill="white">
                      <path d="M10.4414 6.96582L5.3429 0.777652L0.244385 6.96582" />
                    </mask>
                    <path
                      d="M5.3429 0.777652L6.50057 -0.176173L5.3429 -1.58127L4.18522 -0.176173L5.3429 0.777652ZM11.5991 6.012L6.50057 -0.176173L4.18522 1.73148L9.28373 7.91965L11.5991 6.012ZM4.18522 -0.176173L-0.913293 6.01199L1.40206 7.91964L6.50057 1.73148L4.18522 -0.176173Z"
                      fill="black"
                      mask="url(#path-1-inside-1)"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Faqs;

export const query = graphql`
  query FAQsQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
